<template>
  <div class="flex justify-content-between align-items-center">
    <a
      v-if="!disableClose"
      class="heading-3 scroll-label"
      data-cy="section-label"
      @click="$emit('select', section?.id)"
    >
      {{ section?.label }}
    </a>
    <Button
      v-if="!disableClose"
      icon="far fa-times-circle"
      class="p-button-rounded p-button-secondary button-xs"
      data-cy="section-close-button"
      @click="$emit('close', section?.id)"
    />
  </div>
  <div v-if="section" class="calcrow">
    <div
      v-for="d in filteredAggregateDisplays"
      :key="d.label"
      :data-cy="`aggregate-display-${d.label}`"
    >
      <ConverterInput
        v-if="typeof d.value === 'number'"
        :label="d.label || '?'"
        :base-unit="d.base"
        :model="d.model"
        :mode="d.mode"
        :target-unit="d.target"
        :model-value="d.value"
        :update-unit="updateScenario"
        :decimal-places="d.decimalPlaces"
        condensed
      />
      <div v-else class="converter condensed">
        <div class="common">
          <label>{{ d.label }}</label>
          <span class="value body-4">{{ d.value }}</span>
        </div>
      </div>
    </div>
    <div v-if="section.individualDisplays">
      <div
        v-for="individual in section.individualDisplays"
        :key="individual.label"
        class="flex justify-content-between align-items-start my-2"
        :data-cy="`individual-display-${individual.label}`"
      >
        <p class="body-2 mr-2">{{ individual.label }}</p>
        <div>
          <div v-for="d in individual.displays" :key="d.label">
            <ConverterInput
              v-if="typeof d.value === 'number'"
              :key="d.label"
              :label="d.label || '?'"
              :base-unit="d.base"
              :model="d.model"
              :mode="d.mode"
              :model-value="d.value"
              :target-unit="d.target"
              :decimal-places="d.decimalPlaces"
              condensed
            />
            <div v-else class="converter condensed">
              <div class="common">
                <label>{{ d.label }}</label>
                <span class="value body-4">{{ d.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ConverterInput from "@/components/ConverterInput.vue";
import type { Section } from "@/composables/scenarioCalculations/useEquipmentCalculatorSections";
import type { EquipmentCalculatorSectionKey } from "@/composables/scenarioCalculations/calculationTypes";
import { computed } from "vue";

defineEmits<{
  (e: "close", value: EquipmentCalculatorSectionKey | undefined): void;
  (e: "select", value: EquipmentCalculatorSectionKey | undefined): void;
}>();

const props = defineProps<{
  section: Section | undefined;
  disableClose?: boolean;
  updateScenario?: boolean;
  isEspOnShore?: boolean;
}>();

const filteredAggregateDisplays = computed(() => {
  if (!props.section) return [];
  const blacklist =
    props.isEspOnShore === false
      ? [
          "Tubing Flow Regime",
          "Tubing Friction Loss",
          "Casing Friction Loss",
          "Productivity Index",
          "Datum Point",
          "SBHP",
          "PBHP",
          "Axial Bolt Load @ Discharge",
          "Axial Shut-In Bolt Load @ Discharge",
          "Upper Chamber % Upon Pull"
        ]
      : [];

  return props.section.aggregateDisplays.filter(
    d => !blacklist.includes(d.label)
  );
});
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}
</style>
